import React from "react";
import {
  Divider,
  Collapse
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {
  KeyboardArrowUp,
  KeyboardArrowDown
} from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { changeLocale } from "../../../../../redux/stores/profile";
import FlagCn from "../../../../../assets/svg/countries/cn.svg";
import FlagEn from "../../../../../assets/svg/countries/en.svg";
import FlagEs from "../../../../../assets/svg/countries/es.svg";
import FlagRu from "../../../../../assets/svg/countries/rus.svg";
import FlagTr from "../../../../../assets/svg/countries/tr.svg";
import getTrans from "../../../../../languages/getTrans";

const SelectLanguages = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const currentLocale = useSelector(state => state.profile?.locale || "en");

  const options = React.useMemo(() => [
    {
      code: "ru",
      name: getTrans('selectLanguages.Русский'),
      flag: FlagRu
    },
    {
      code: "en",
      name: getTrans('selectLanguages.English'),
      flag: FlagEn
    },
    {
      code: "es",
      name: getTrans('selectLanguages.Español'),
      flag: FlagEs
    },
    {
      code: "cn",
      name: getTrans('selectLanguages.中文'),
      flag: FlagCn
    },
    {
      code: "tr",
      name: getTrans('selectLanguages.Türkçe'),
      flag: FlagTr
    }
  ], [currentLocale]);
  const activeLanguage = options.find(opt => opt.code === currentLocale) || options[1];
  const handleLanguageChange = (localeCode) => {
    if (localeCode === currentLocale) {
      setIsOpen(false);
      return;
    }

    dispatch(changeLocale(localeCode));
    setIsOpen(false);

    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  const [isOpen, setIsOpen] = React.useState(false);
  const IconOpen = isOpen ? KeyboardArrowUp : KeyboardArrowDown;
  const handleChangeOpen = (val) => {
    setIsOpen(val);
  }


  return (
    <div>
      <div className={classes.title}>{getTrans('header.Выбор языка')}</div>
      <div className={classes.select}>
        <div
          className={classes.selectRow}
          onClick={handleChangeOpen.bind(null, !isOpen)}
          style={{ cursor: "pointer" }}
        >
          <div className={classes.selectRowIcon}>
            <img src={activeLanguage.flag} alt={activeLanguage.name}/>
          </div>
          <div className={classes.selectRowName}>{activeLanguage.name}</div>

          <div className={classes.selectRowArrow}>
            <IconOpen sx={{color: '#FB7800'}}/>
          </div>
        </div>

        <Collapse in={isOpen}>
          <div className={classes.selectBody}>
            {options.map((item, index) => {
              const isActive = item.code === currentLocale;
              return (
                <React.Fragment key={item.code}>
                  {index > 0 && <Divider sx={{borderColor: "#FFFFFF1A"}}/>}
                  <div
                    className={`${classes.selectRow} ${isActive ? classes.selectRowActive : ''}`}
                    onClick={() => handleLanguageChange(item.code)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={classes.selectRowIcon}>
                      <img src={item.flag} alt={item.name}/>
                    </div>
                    <div className={classes.selectRowName}>{item.name}</div>
                    {isActive && <div className={classes.selectRowCheck}>✓</div>}
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </Collapse>
      </div>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  title: {
    opacity: "0.5",
    marginBottom: "4px",

    fontSize: 15,
    color: "white",
    lineHeight: "18px"
  },

  select: {
    borderRadius: "8px",
    background: "#FFFFFF0D",
    border: "1px solid #FFFFFF1A",
  },
  selectBody: {
  },

  selectRow: {
    gap: "10px",
    height: "40px",
    display: "flex",
    padding: "0 8px",
    alignItems: "center",
    boxSizing: "border-box",

    color: "white",
    fontSize: "18px",
    fontWeight: "500",
    lineHeight: "22px",
  },
  selectRowArrow: {
    width: 40,
    height: 40,
    display: "flex",
    marginLeft: "auto",
    alignItems: "center",
    justifyContent: "center",
  },
  selectRowIcon: {
    width: 24,
    height: 24,
    overflow: "hidden",
    borderRadius: "100%",
    position: "relative",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "50% 50%",
    }
  },
  selectRowActive: {
    backgroundColor: "#FFFFFF0A",
  },
  selectRowCheck: {
    marginLeft: "auto",
    fontSize: "20px",
    color: "#40a7e3",
  }
}));

export default SelectLanguages;
